import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import client from "@/lib/api";

/**
 * Compact widget: live sales count + "Top of season" arcade teaser + game-hunt counter.
 */
export default function HomeStatsRail() {
  const [sold, setSold] = useState(null);
  const [board, setBoard] = useState(null);
  const [arcadeStats, setArcadeStats] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const load = () => {
      client.get("/stats/sold").then((r) => { if (!cancelled) setSold(r.data); }).catch(() => {});
      client.get("/arcade/leaderboard").then((r) => { if (!cancelled) setBoard(r.data); }).catch(() => {});
      client.get("/arcade/stats").then((r) => { if (!cancelled) setArcadeStats(r.data); }).catch(() => {});
    };
    load();
    const handle = setInterval(load, 60000);
    return () => { cancelled = true; clearInterval(handle); };
  }, []);

  if (!sold) return null;
  const total = (sold.total || 0).toLocaleString();
  const topScore = board?.leaderboard?.[0]?.score;
  const topName = board?.leaderboard?.[0]?.name;
  const totalGames = arcadeStats?.total_games_played;
  const toMillion = arcadeStats?.next_million_drop_in;

  return (
    <section className="bg-[#FAFAFA] border-y border-black/10" data-testid="home-stats-rail">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 py-4 flex flex-wrap items-center justify-between gap-x-10 gap-y-3">
        <div className="flex items-baseline gap-3" data-testid="sales-info-bar">
          <span className="label-eyebrow text-black/40">Studio ledger</span>
          <span className="font-display text-2xl tracking-tighter moto-accent" data-testid="sales-count">{total}</span>
          <span className="label-eyebrow text-black/60">garments shipped</span>
        </div>

        {totalGames !== undefined && toMillion !== undefined && (
          <div
            className="flex items-baseline gap-3"
            title="Find the hidden link to the game. When the global counter hits the next million, the next lucky player wins 2 free T-shirts."
            data-testid="home-pi-hunt"
          >
            <span className="label-eyebrow text-black/40">Game hunt</span>
            <span className="font-display text-2xl tracking-tighter">{totalGames.toLocaleString()}</span>
            <span className="label-eyebrow text-black/60">
              <span className="text-[#FF3B30] font-semibold">{toMillion.toLocaleString()}</span> to 2 free tees
            </span>
          </div>
        )}

        <Link
          to="/arcade"
          className="group flex items-baseline gap-3 hover:moto-accent transition-colors"
          data-testid="home-arcade-widget"
        >
          <span className="label-eyebrow text-black/40 group-hover:moto-accent">Top of season</span>
          {topScore !== undefined ? (
            <>
              <span className="font-display text-2xl tracking-tighter">{topScore.toLocaleString()}</span>
              <span className="label-eyebrow text-black/60 group-hover:moto-accent">by {topName || "Anonymous"}</span>
            </>
          ) : (
            <span className="label-eyebrow text-black/60 group-hover:moto-accent">No score yet — claim it</span>
          )}
        </Link>
      </div>
    </section>
  );
}
